import { addMessages } from '@hana/i18n';

// Khoá chuỗi cdk.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'cdk.1': "Tổng hợp tháng 10",
  'cdk.2': "Đề nghị theo bước duyệt",
  'cdk.3': "Chờ HĐ theo tuổi",
  'cdk.4': "Chi theo dịch vụ",
  'cdk.5': "Tỷ lệ thu hồi HĐ ĐỐI TÁC",
  'cdk.6': "Chi phí có HĐ theo tháng",
  'cdk.7': "Theo loại chi phí · tháng 10",
  'cdk.8': "Đối tác lớn nhất · tháng 10",
  'cdk.9': "Bước của tôi: Kế toán [ACC-CP] LIENNTK",
  'cdk.10': "Bạn là người lập phiếu này — không ký hai bước",
  'cdk.11': "Duyệt",
  'cdk.12': "Trả về",
  'cdk.13': "Không còn phiếu chờ bạn duyệt.",
});
addMessages('en', {
  'cdk.1': "October summary",
  'cdk.2': "Requests by approval step",
  'cdk.3': "Awaiting invoice by age",
  'cdk.4': "Spend by service",
  'cdk.5': "PARTNER invoice recovery rate",
  'cdk.6': "Costs with invoice by month",
  'cdk.7': "By cost type · October",
  'cdk.8': "Largest partners · October",
  'cdk.9': "My step: Accountant [ACC-CP] LIENNTK",
  'cdk.10': "You prepared this slip — no double signing",
  'cdk.11': "Approve",
  'cdk.12': "Return",
  'cdk.13': "No slips awaiting your approval.",
});
